import * as OfflinePluginRuntime from 'offline-plugin/runtime'
OfflinePluginRuntime.install()

import Vue from 'vue'
import App from './App.vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
import SocialSharing from 'vue-social-sharing'
import VueAnalytics from 'vue-ua'

Vue.use(VueMaterial)
Vue.use(SocialSharing)

Vue.use(VueAnalytics, {
  appName: 'Business Site', // Mandatory
  appVersion: '1.0.0', // Mandatory
  trackingId: 'UA-91383222-1', // Mandatory
  debug: false
})

Vue.material.registerTheme('default', {
  primary: {
    color: 'purple',
    hue: '500'
  }
})

new Vue({
  components: {
    App
  },
  render: (h) => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js